'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _MatrixClientPeg = require('../../../MatrixClientPeg');

var _MatrixClientPeg2 = _interopRequireDefault(_MatrixClientPeg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
Copyright 2019 The Matrix.org Foundation C.I.C.

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

var ReactionTooltipButton = function (_React$PureComponent) {
    (0, _inherits3.default)(ReactionTooltipButton, _React$PureComponent);

    function ReactionTooltipButton() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, ReactionTooltipButton);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ReactionTooltipButton.__proto__ || (0, _getPrototypeOf2.default)(ReactionTooltipButton)).call.apply(_ref, [this].concat(args))), _this), _this.onClick = function (ev) {
            var _this$props = _this.props,
                mxEvent = _this$props.mxEvent,
                myReactionEvent = _this$props.myReactionEvent,
                content = _this$props.content;

            if (myReactionEvent) {
                _MatrixClientPeg2.default.get().redactEvent(mxEvent.getRoomId(), myReactionEvent.getId());
            } else {
                _MatrixClientPeg2.default.get().sendEvent(mxEvent.getRoomId(), "m.reaction", {
                    "m.relates_to": {
                        "rel_type": "m.annotation",
                        "event_id": mxEvent.getId(),
                        "key": content
                    }
                });
            }
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(ReactionTooltipButton, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                content = _props.content,
                myReactionEvent = _props.myReactionEvent;


            var classes = (0, _classnames2.default)({
                mx_ReactionTooltipButton: true,
                mx_ReactionTooltipButton_selected: !!myReactionEvent
            });

            return _react2.default.createElement(
                'span',
                { className: classes,
                    'data-key': content,
                    title: this.props.title,
                    'aria-hidden': true,
                    onClick: this.onClick
                },
                content
            );
        }
    }]);
    return ReactionTooltipButton;
}(_react2.default.PureComponent);

ReactionTooltipButton.propTypes = {
    mxEvent: _propTypes2.default.object.isRequired,
    // The reaction content / key / emoji
    content: _propTypes2.default.string.isRequired,
    title: _propTypes2.default.string,
    // A possible Matrix event if the current user has voted for this type
    myReactionEvent: _propTypes2.default.object
};
exports.default = ReactionTooltipButton;
module.exports = exports['default'];
//# sourceMappingURL=ReactionTooltipButton.js.map